import styles from './styles.module.scss';

const NetworkType = ({ t, value, level }) => {
  return (
    <div
      className={`
      ${styles.networkType} 
      ${
        level > 79
          ? styles.networkTypeFull
          : level > 20
            ? styles.networkTypeMiddle
            : level !== null
              ? styles.networkTypeEmpty
              : ''
      }
      `}
    >
      {<div className={styles.networkTypeIcon}></div>}
      {value ? value : t('empty.noNetwork')}
    </div>
  );
};

export default NetworkType;
